import { Endpoints, generateAxios } from '@matap/shared';
import { generateMutation, generateQuery, generateDataQueryHook } from './create-hooks';

export const useVisitPreview = generateQuery(Endpoints.visits.user.preview, (endpoint, payload) => ({
  queryKey: ['useVisitPreview', payload.query],
  queryFn: () => generateAxios(endpoint, payload).then((r) => r.data),
}));

export const useInitiateVisit = generateMutation(Endpoints.visits.user.initiateVisit, (endpoint) => ({
  mutationFn: (payload) => generateAxios(endpoint, payload).then((r) => r.data),
}));

export const useAcceptVisit = generateMutation(Endpoints.visits.user.accept, (endpoint) => ({
  mutationFn: (payload) => generateAxios(endpoint, payload).then((r) => r.data),
}));

export const useEndVisit = generateMutation(Endpoints.visits.user.end, (endpoint) => ({
  mutationFn: (payload) => generateAxios(endpoint, payload).then((r) => r.data),
}));

export const useQueryVisits = generateDataQueryHook(Endpoints.visits.user.query, {
  queryKey: 'useQueryVisits',
});
